import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Card, Typography, Tooltip, IconButton } from "@mui/material";
import TopSection from "../../../LT/TopSection";
import ButtonComponent from "../../../../components/common/button/Button";
import DataTable from "../../../../components/common/datatable/DataTable";
import { fetchData, putData } from "../../../../redux/actions/apiSlice";
import { postSupplierConfirmation } from "../../../../redux/actions/supplierConfirmationSlice";
import ManagePrsTable from "../ManagePrsTable";
import { toast } from 'react-toastify';
import {
 
 
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import Modal from "../../../../components/common/modal/Modal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GraphComponent from "../../../../components/common/graph/GraphComponent";
import SupplierWeeklyTable from "./SupplierWeeklyTable";  
import "./SuplierDetails.css";
import { SupplierTableHeaders } from "./SupplierTableHeaders";
import { fetchSupplyDrilldown } from "../../../../redux/actions/supplyDrilldownSlice";
import { getSupplyDrilldown } from "../../../../common/endpoints";
import { fetchPurchaseRequisition } from "../../../../redux/actions/purchaseRequisitionSlice";
import { getPurchaseRequisition } from "../../../../common/endpoints";
import { formatDateToDDMMYYYY } from "../../../../utils/dateUtils";
const normalizeRole = (role) => (role || "").replace(/\s+/g, "").toLowerCase();
const hasRole = (rawRole, target) =>
  normalizeRole(rawRole).split(",").some((r) => r === target);
const SuplierDetails = () => {
 
  const { materialId, plantId, supplierId,supplierName  } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const data = useSelector((state) => state.api?.data);
  const loading = useSelector((state) => state.api?.loading);
  const error = useSelector((state) => state.api?.error);
  const rawRole = localStorage.getItem("appUserRole") || "";
  const isGlobalViewer = (hasRole(rawRole, "globalviewer") || hasRole(rawRole, "viewer"))
    && !hasRole(rawRole, "appadmin") && !hasRole(rawRole, "globalplanner") && !hasRole(rawRole, "planner");

  const drilldownData = useSelector((state) => state.supplyDrilldown?.data);
  const drilldownLoading = useSelector((state) => state.supplyDrilldown?.loading);
  const drilldownError = useSelector((state) => state.supplyDrilldown?.error);
  const [showManageModal, setShowManageModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const prData = useSelector((state) => state.purchaseRequisition?.data);
  const prLoading = useSelector((state) => state.purchaseRequisition?.loading);
  const description =
    state?.description ||
    data?.meta?.description || // if your API nests metadata
    data?.description ||       // or flat shape
    "";
  const drilldownMeta = Array.isArray(drilldownData?.data?.rows)
    ? drilldownData.data.rows[0]
    : Array.isArray(drilldownData?.data)
      ? drilldownData.data[0]
      : null;
  const materialGroup =
    state?.materialGroupDesc ??
    state?.materialGroup ??
    data?.materialGroupDesc ??
    data?.materialGroup ??
    drilldownMeta?.materialGroupDesc ??
    drilldownMeta?.materialGroup ??
    "";
  const purchaseGroup =
    state?.purchasingGroup ??
    state?.purchaseGroup ??
    data?.purchasingGroup ??
    data?.purchaseGroup ??
    drilldownMeta?.purchasingGroup ??
    drilldownMeta?.purchaseGroup ??
    "";
  const mrpController =
    state?.mrpController ??
    state?.mrpCtrl ??
    data?.mrpController ??
    data?.mrpCtrl ??
    drilldownMeta?.mrpController ??
    drilldownMeta?.mrpCtrl ??
    "";
  const displayOrDash = (value) =>
    value === undefined || value === null || value === "" ? "—" : value;

     const [selectedPeriodForecast, setSelectedPeriodForecast] = useState("All");
const [selectedPeriodDelta, setSelectedPeriodDelta] = useState("All");
  const PERIOD_TO_WEEKS = {
    "4W": 4,
    "8W": 8,
    "13W": 13,
    "26W": 26,
    "All": null,
  };

    const [graphModalOpen, setGraphModalOpen] = useState(false);
  const [activeGraph, setActiveGraph] = useState(null);

  const openGraphModal = (key) => {
    setActiveGraph(key);
    setGraphModalOpen(true);
  };

  const closeGraphModal = () => {
    setGraphModalOpen(false);
  };


  //  const supplierNameFromState = state?.supplierName || "";
  
  


const supplierRowsFromState = state?.supplierRows || [];
  const supplierOptions = useMemo(() => {
    if (supplierRowsFromState.length) return supplierRowsFromState;
    if (state?.supplierRow) return [state.supplierRow];
    // Fallback on refresh: build a minimal option from URL params
    if (supplierId) return [{ supplierId, supplier: supplierId, supplierName: supplierName || "" }];
    return [];
  }, [supplierRowsFromState, state, supplierId, supplierName]);

  const [selectedSupplierId, setSelectedSupplierId] = useState(
    supplierId || supplierOptions[0]?.supplierId || supplierOptions[0]?.supplier || ""
  );

  useEffect(() => {
    if (supplierId) setSelectedSupplierId(supplierId);
  }, [supplierId]);

  const selectedSupplierRow = useMemo(() => {
    return supplierOptions.find(
      (s) => (s?.supplierId || s?.supplier) === selectedSupplierId
    );
  }, [supplierOptions, selectedSupplierId]);

  const rawSupplierName =
    selectedSupplierRow?.supplierName || supplierName || state?.supplierName || "";
  const selectedSupplierName = (rawSupplierName === "—" || rawSupplierName === "-") ? "" : rawSupplierName;

  const selectedSupplierStatus =
    selectedSupplierRow?.confirmed === "Yes"
      ? "Confirmed"
      : "Confirmation Pending";

  const alCommandCenterBaseUrl =
    (process.env.REACT_APP_CC_BASE_URL || "").replace(/\/+$/, "");
  const alternateSourcingUrl = `${alCommandCenterBaseUrl}/core/inventory/node/inventory/inventory-detail/${encodeURIComponent(
    materialId || ""
  )}/${encodeURIComponent(plantId || "")}`;
 

const formatShortDate = (dateStr) => {
  if (!dateStr) return "N/A";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    })
    .replace(/ /g, "-");
};

const getFirstDateValue = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "" && value !== "—" && value !== "-" && value !== "N/A") || "N/A";

const forecastDateInfo = useMemo(() => {
  const header = drilldownData?.data?.header ?? drilldownData?.header ?? null;
  const raw = Array.isArray(drilldownData?.data) ? drilldownData.data[0] : null;
  const publishedRaw = getFirstDateValue(
    header?.forecastPublishedDate,
    header?.publicationDate,
    header?.PUBLICATION_DATE,
    raw?.publicationDate,
    raw?.PUBLICATION_DATE,
    raw?.publication_date,
    raw?.creationDate,
    raw?.CREATION_DATE,
    raw?.creation_date
  );
  const currentRaw = getFirstDateValue(
    header?.currentSAPForecastDate,
    header?.currentForecastDate,
    header?.CURRENT_FORECAST_DATE,
    raw?.currentForecastDate,
    raw?.CURRENT_FORECAST_DATE,
    raw?.current_forecast_date
  );
  const confirmationRaw = getFirstDateValue(
    header?.confirmationDate,
    header?.CONFIRMATION_DATE,
    raw?.confirmationDate,
    raw?.CONFIRMATION_DATE,
    raw?.confirmation_date,
    raw?.confirmedDate,
    raw?.CONFIRMED_DATE,
    raw?.confirmed_date
  );
  const extractionRaw = getFirstDateValue(
    header?.extractionDate,
    header?.EXTRACTION_DATE,
    raw?.extractionDate,
    raw?.EXTRACTION_DATE,
    raw?.extraction_date
  );
  return {
    published: formatDateToDDMMYYYY(publishedRaw),
    current: formatDateToDDMMYYYY(currentRaw),
    confirmation: formatDateToDDMMYYYY(confirmationRaw),
    extraction: formatDateToDDMMYYYY(extractionRaw),
  };
}, [drilldownData]);

  
 

  useEffect(() => {
    if (!materialId || !plantId || !selectedSupplierId) return;
    dispatch(
      fetchSupplyDrilldown({
        dynamicEndpoint: `${getSupplyDrilldown}?Plant=${encodeURIComponent(plantId)}&Material=${encodeURIComponent(materialId)}&Supplier=${encodeURIComponent(selectedSupplierId)}`,
      })
    );
  }, [dispatch, materialId, plantId, selectedSupplierId]);

   const tableRows = useMemo(() => {
    const rows = Array.isArray(drilldownData?.data?.rows)
      ? drilldownData.data.rows
      : Array.isArray(drilldownData?.data)
        ? drilldownData.data
        : [];
    if (rows.length) {
      return rows.map((item, index) => ({
        id: index,
        weekStartDate: item.GRDate ?? "N/A",
        
        originalForecast: item.totalSupplierForecastOriginal != null ? Number(item.totalSupplierForecastOriginal) : "N/A",
        sumOfForecast: item.totalSupplierForecastCurrent != null ? Number(item.totalSupplierForecastCurrent) : "N/A",
        supplierQuantityConfirmation: item.totalSupplierConfirmation != null ? Number(item.totalSupplierConfirmation) : "N/A",
        deltaCumulativeCurrent: item.delta != null ? Number(item.delta) : "N/A",
        pdt: item.pdt != null ? `${item.pdt}d` : "N/A",
        supplierId: item.supplier ?? selectedSupplierId,
        description: item.descriptions ?? "N/A",
        plant: item.plant ?? plantId,
        material: item.material ?? materialId,
        mrpController: item.mrpController ?? "N/A",
        purchasingGroup: item.purchasingGroup ?? "N/A",
        materialGroupDesc: item.materialGroupDesc ?? "N/A",
        supplierComment: item.supplierComment ?? item.supplierComments,
        grdateInDays: (() => {
          const v = item.grdateInDays;
          if (v == null) return "N/A";
          const n = Number(v);
          return Number.isNaN(n) ? v : n;
        })(),
      }));
    }
    // No API data available — return an empty set rather than demo rows
    return [];
    
  }, [drilldownData, selectedSupplierId]);

  

  const handleBack = () => navigate("/dashboard");
  const openManageModal = () => {
    if (materialId && plantId && selectedSupplierId) {
      const endpoint = `${getPurchaseRequisition}?plant=${encodeURIComponent(plantId)}&material=${encodeURIComponent(materialId)}&supplier=${encodeURIComponent(selectedSupplierId)}`;
      dispatch(fetchPurchaseRequisition({ dynamicEndpoint: endpoint }));
    }
    setShowManageModal(true);
  };
  const closeManageModal = () => setShowManageModal(false);

  const handleSendToIBP = () => {
    if (!filteredRowsBySupplier || !filteredRowsBySupplier.length) return;

    const payload = filteredRowsBySupplier.map((r) => ({
      LOCID: plantId,
      LOCFR: selectedSupplierId,
      PRDID: materialId,
      MOTID: "DEF",
      PERIODID4_TSTAMP: r.grdateInDays,
      ZSUPPLIERCONFIRMEDFORECAST: Number(r.supplierQuantityConfirmation) || 0,
    }));

    dispatch(postSupplierConfirmation({ data: payload }))
      .unwrap()
        .then((res) => {
          toast.success("Data sent to IBP successfully", { autoClose: 4000 });
        })
        .catch((err) => {
          console.error("Send to IBP error:", err);
          const msg = err?.message || (err && err.status) || "Failed to send data to IBP";
          toast.error(msg, { autoClose: 4000 });
        });
  };



const filteredRowsBySupplier = useMemo(() => {
    if (!selectedSupplierId) return tableRows;
    const hasSupplierKey = (tableRows || []).some(
      (r) => r?.supplierId || r?.supplier
    );
    if (!hasSupplierKey) return tableRows;

    return (tableRows || []).filter(
      (r) => (r?.supplierId || r?.supplier) === selectedSupplierId
    );
  }, [tableRows, selectedSupplierId]);

 const filteredChartRows = useMemo(() => {
  const weeks = PERIOD_TO_WEEKS[selectedPeriodForecast];
  if (!weeks) return filteredRowsBySupplier;

  const sorted = [...filteredRowsBySupplier].sort(
    (a, b) => new Date(a.weekStartDate) - new Date(b.weekStartDate)
  );

  const latest = sorted[sorted.length - 1]?.weekStartDate;
  if (!latest) return sorted;

  const latestDate = new Date(latest);
  const cutoff = new Date(latestDate);
cutoff.setDate(cutoff.getDate() - (weeks - 1) * 7);

  return sorted.filter((r) => new Date(r.weekStartDate) >= cutoff);
}, [filteredRowsBySupplier, selectedPeriodForecast]);

const filteredDeltaRows = useMemo(() => {
  const weeks = PERIOD_TO_WEEKS[selectedPeriodDelta];
  if (!weeks) return filteredRowsBySupplier;

  const sorted = [...filteredRowsBySupplier].sort(
    (a, b) => new Date(a.weekStartDate) - new Date(b.weekStartDate)
  );

  const latest = sorted[sorted.length - 1]?.weekStartDate;
  if (!latest) return sorted;

  const latestDate = new Date(latest);
  const cutoff = new Date(latestDate);
  cutoff.setDate(cutoff.getDate() - (weeks - 1) * 7);

  return sorted.filter((r) => new Date(r.weekStartDate) >= cutoff);
}, [filteredRowsBySupplier, selectedPeriodDelta]);


  const chartData = useMemo(() => {
    // Use raw grdate format from API for x-axis labels
    const labels = (filteredChartRows || []).map((r) => r.weekStartDate || "—");
    return {
      labels,
      datasets: [
        {
          label: "Total Supplier Forecast(Current)",
          data: (filteredChartRows || []).map((r) => r.sumOfForecast ?? 0),
          backgroundColor: "#94a3b8",
          barThickness: 10,
        },
        {
          label: "Total Supplier Confirmation",
          data: (filteredChartRows || []).map(
            (r) => r.supplierQuantityConfirmation ?? 0
          ),
          backgroundColor: "#ef4444",
          barThickness: 10,
        },
      ],
    };
  }, [filteredChartRows]);

  const deltaChartData = useMemo(() => {
    // Use raw grdate format from API for x-axis labels
    const labels = (filteredDeltaRows || []).map((r) => r.weekStartDate || "—");
    return {
      labels,
      datasets: [
        {
         label: "Delta (Cumulative) Current",
  type: "line",
  data: (filteredDeltaRows || [])
  .map(r => r.deltaCumulativeCurrent),
  borderColor: "rgba(139,92,246,0.8)",
  backgroundColor: "rgba(139,92,246,0.15)",
  borderWidth: 0.75,
  tension: 0,
  fill: false,
  pointRadius: 1,
  pointHoverRadius: 3,
        },
      ],
    };
  }, [filteredDeltaRows]);

  const chartOptions = useMemo(
    () => ({
      responsive: true,
      plugins: { legend: { position: "bottom" } },
      scales: {
        x: { grid: { display: false } },
        y: { beginAtZero: true },
      },
       animation: { duration: 200, easing: "easeOutQuart" },
    transitions: {
      active: { animation: { duration: 200 } },
      resize: { animation: { duration: 0 } },
    },
    }),
    []
  );


const modalChartOptions = useMemo(
    () => ({
      ...chartOptions,
      maintainAspectRatio: false,
    }),
    [chartOptions]
  );

  const graphConfig = useMemo(
    () => ({
      forecast: {
        title: "Total Supplier Forecast vs Total Supplier Confirmation",
        data: chartData,
        period: selectedPeriodForecast,
        onPeriodChange: setSelectedPeriodForecast,
      },
      delta: {
        title: "Delta (Cumulative) Current",
        data: deltaChartData,
        period: selectedPeriodDelta,
        onPeriodChange: setSelectedPeriodDelta,
      },
    }),
    [chartData, deltaChartData, selectedPeriodForecast, selectedPeriodDelta]
  );

  const modalGraphData = useMemo(() => {
    if (!activeGraph) return null;
    const base = graphConfig[activeGraph]?.data;
    if (!base) return null;

   if (activeGraph === "forecast") {
      return {
        ...base,
        datasets: base.datasets.map((ds) => ({
          ...ds,
          barThickness: 12,
          maxBarThickness: 18,
        })),
      };
    }

    if (activeGraph === "delta") {
      return {
        ...base,
        datasets: base.datasets.map((ds) => ({
          ...ds,
           borderWidth: 1,
      pointRadius: 1,
      pointHoverRadius: 3,
      tension: 0,
        })),
      };
    }

    return base;
  }, [activeGraph, graphConfig]);


  return (
    <Box sx={{ width: "100%" }}>
      <TopSection
        labelList={[
          
          { title: "Dashboard", path: "/dashboard" },
          { title: `${materialId}` , path: `/dashboard/material/${materialId}/${plantId}` },
           ...(selectedSupplierName ? [{ title: selectedSupplierName }] : []),
        ]}
        hideHeader={true}
        titlePadding="0"
      />

    <Card
  sx={{
    width: "96%",
    margin: "8px auto",
    borderRadius: 3,
    padding: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
  }}
>
  {/* LEFT SECTION */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
    {/* Material Info */}
    <Box>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: "#64748b",
          letterSpacing: 1,
        }}
      >
        SUPPLIER DETAIL VIEW
      </Typography>

      <Typography
        variant="h5"
        sx={{ fontWeight: 700, mt: 0.5 }}
      >
        {supplierId}
      </Typography>

      <Typography
        variant="body2"
        sx={{ color: "#64748b" }}
      >
        {description}
      </Typography>
    </Box>

    {/* Divider */}
    <Box sx={{ width: "1px", height: 50, backgroundColor: "#e5e7eb" }} />

    {/* Plant */}
    <Box>
      <Typography variant="caption" sx={{ color: "#64748b" }}>
        PLANT CODE
      </Typography>
      <Typography sx={{ fontWeight: 600 }}>
        {plantId}
      </Typography>
    </Box>

    {/* Material Group */}
    <Box>
      <Typography variant="caption" sx={{ color: "#64748b" }}>
        MATERIAL GROUP DESCRIPTION
      </Typography>
      <Typography sx={{ fontWeight: 600 }}>
        {displayOrDash(materialGroup)}
      </Typography>
    </Box>

    {/* Purchase Group */}
    <Box>
      <Typography variant="caption" sx={{ color: "#64748b" }}>
        PURCHASE GROUP
      </Typography>
      <Typography sx={{ fontWeight: 600 }}>
        {displayOrDash(purchaseGroup)}
      </Typography>
    </Box>

    {/* MRP Controller */}
    <Box>
      <Typography variant="caption" sx={{ color: "#64748b" }}>
        MRP CONTROLLER
      </Typography>
      <Typography sx={{ fontWeight: 600 }}>
        {displayOrDash(mrpController)}
      </Typography>
    </Box>
  </Box>

 
</Card>

    


<Card
        sx={{
          width: "96%",
          margin: "8px auto",
          borderRadius: 3,
          padding: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography sx={{ fontWeight: 600 }}>
            Supplier Selection
          </Typography>
<Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
          <FormControl size="small" sx={{ minWidth: 320 }}>
            <InputLabel id="supplier-select-label">Supplier</InputLabel>
            <Select
              labelId="supplier-select-label"
              value={selectedSupplierId}
              label="Supplier"
              onChange={(e) => {
    const nextSupplierId = e.target.value;
    setSelectedSupplierId(nextSupplierId);

    const nextSupplierName = supplierOptions.find(
      (s) => (s?.supplierId || s?.supplier) === nextSupplierId
    )?.supplierName || "";

    navigate(
      `/dashboard/material/${materialId}/${plantId}/supplier/${nextSupplierId}${nextSupplierName ? `/${encodeURIComponent(nextSupplierName)}` : ""}`,
      {
        state: {
          ...state,
          supplierRows: supplierOptions,
          supplierName: nextSupplierName,
        },
        replace: true,
      }
    );
  }}
  disabled={!supplierOptions.length}
>
              {supplierOptions.map((s) => {
                const id = s?.supplierId || s?.supplier;
                const hasName = s?.supplierName && s.supplierName !== "—" && s.supplierName !== "-";
                const label = hasName ? `${id} - ${s.supplierName}` : id;
                
                return (
                  <MenuItem key={id} value={id}>
                    {label} 
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          {selectedSupplierId && (
            <Chip
              label={selectedSupplierStatus}
              color={selectedSupplierStatus === "Confirmed" ? "success" : "warning"}
              size="small"
            />
          )}
          </Box>
        </Box>
      </Card>





  <Box sx={{  margin: "4px auto",padding:0.25}}>

       <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mt: 1 }}>
          <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2 }}>
           <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 1 }}>
              Total Supplier Forecast vs Total Supplier Confirmation
            </Typography>
            <IconButton size="small" onClick={() => openGraphModal("forecast")}>
                <OpenInFullIcon fontSize="small" />
              </IconButton>
</Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <Typography sx={{ fontWeight: 400, fontSize: 14 }}>PERIOD:</Typography>
              {["4W", "8W", "13W", "26W", "All"].map((p) => (
                <ButtonComponent
                  key={p}
                  label={p}
                  type="primary"
                  size="small"
                  bgColor={selectedPeriodForecast === p ? "#2563eb" : "#f1f5f9"}
                  color={selectedPeriodForecast === p ? "white" : "black"}
                  sx={{ minWidth: 40, height: 26, px: 1, fontSize: "0.75rem" }}
                  onClick={() => setSelectedPeriodForecast(p)}
                />
              ))}
               <Tooltip
                  title={
                    <span>
                      Forecast Published Date: {forecastDateInfo.published}<br />
                      Current SAP Forecast Date: {forecastDateInfo.current}<br />
                      Confirmation Date: {forecastDateInfo.confirmation}<br />
                      Extraction Date: {forecastDateInfo.extraction}<br />
                    </span>
                  }
                  arrow
                >
                <IconButton size="small" aria-label="Info for forecast period">
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>

            <GraphComponent data={chartData} options={chartOptions} />
          </Box>

          <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 2, p: 2 }}>
           <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 1 }}>
              Delta (Cumulative) Current 
            </Typography>
            <IconButton size="small" onClick={() => openGraphModal("delta")}>
                <OpenInFullIcon fontSize="small" />
              </IconButton>
</Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <Typography sx={{ fontWeight: 400, fontSize: 14 }}>PERIOD:</Typography>
              {["4W", "8W", "13W", "26W", "All"].map((p) => (
                <ButtonComponent
                  key={p}
                  label={p}
                  type="primary"
                  size="small"
                  bgColor={selectedPeriodDelta === p ? "#2563eb" : "#f1f5f9"}
                  color={selectedPeriodDelta === p ? "white" : "black"}
                  sx={{ minWidth: 40, height: 26, px: 1, fontSize: "0.75rem" }}
                  onClick={() => setSelectedPeriodDelta(p)}
                />
              ))}
            </Box>

            <GraphComponent data={deltaChartData} options={chartOptions} />
          </Box>
        </Box>
        <div className="supplier-analysis-table-section">
          <div className="supplier-analysis-table-header">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
              <div>
                <div className="supplier-analysis-table-title">
                  Time-Phased Supplier Confirmation - By GR Date
                </div>
                <div className="supplier-analysis-table-subtitle">
                  Supplier: {selectedSupplierName}
                </div>
              </div>
<div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
              <ButtonComponent
                label="Manage PR"
                type="primary"
                bgColor="#111010ff"
                color="white"
                onClick={openManageModal}
              />
                 <ButtonComponent
                label="Send to IBP"
                type="primary"
                bgColor="#2563eb"
                color="white"
                disabled={isGlobalViewer}
                  onClick={handleSendToIBP}
              />
              </div>
            </div>

            <div style={{ position: 'relative', minHeight: 400 }}>
              <SupplierWeeklyTable rows={filteredRowsBySupplier} dateInfo={forecastDateInfo} />
            </div>
          </div>
        </div>
      </Box>


 <Modal
        open={showManageModal}
        handleClose={closeManageModal}
        fullWidth
        maxWidth="lg"
        title={
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              width: "100%",
              pr: 6,
              flexWrap: "wrap",
            }}
          >
            <Box>
              <Typography sx={{ fontWeight: 600 }}>
                Open Purchase Requisitions (PR)
              </Typography>
              <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
                Material: {materialId} | Supplier: {selectedSupplierName}
              </Typography>
            </Box>
            <Typography
              component="a"
              href={alternateSourcingUrl}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#1976d2",
                textDecoration: "none",
                fontWeight: 500,
                border: "1px solid #1976d2",
                borderRadius: "6px",
                px: 1,
                py: 0.25,
                fontSize: "0.75rem",
                display: "inline-block",
                mr: 4,
              }}
            >
              Alternate Sourcing(Command Center)
            </Typography>
          </Box>
        }
        content={
    <Box sx={{ height: "60vh", overflow: "auto" }}>
      <ManagePrsTable rows={(prData && prData.data) || prData || []} onSelectionChange={setSelectedRows} />
    </Box>
  }
        action={
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
              {selectedRows?.length > 0
                ? `${selectedRows.length} Item${selectedRows.length > 1 ? "s" : ""} Selected`
                : ""}
            </Typography>
            <Box sx={{ display: "flex", gap: 1 }}>
              <ButtonComponent
                label="Close"
                type="primary"
                bgColor="#FFFFFF"
                color="black"
                onClick={closeManageModal}
              />
           {/*   <ButtonComponent
                label="Firm Selected"
                type="primary"
                bgColor="#f53c00"
                color="white"
                disabled={!selectedRows || selectedRows.length === 0}
                onClick={() => {
                  closeManageModal();
                }}
              /> 
              */}
            </Box>
          </Box>
        }
      />







<Modal
        open={graphModalOpen}
        handleClose={closeGraphModal}
        onExited={() => setActiveGraph(null)}
        fullWidth
        maxWidth="xl"
        title={graphConfig[activeGraph]?.title || "Graph"}
        content={
          activeGraph ? (
            <Box >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, flexWrap: "wrap" }}>
                <Typography sx={{ fontWeight: 400, fontSize: 14 }}>PERIOD:</Typography>
                {["4W", "8W", "13W", "26W", "All"].map((p) => (
                  <ButtonComponent
                    key={p}
                    label={p}
                    type="primary"
                    size="small"
                    bgColor={graphConfig[activeGraph]?.period === p ? "#2563eb" : "#f1f5f9"}
                    color={graphConfig[activeGraph]?.period === p ? "white" : "black"}
                    sx={{ minWidth: 40, height: 26, px: 1, fontSize: "0.75rem" }}
                    onClick={() => graphConfig[activeGraph]?.onPeriodChange?.(p)}
                  />
                ))}
                {activeGraph === "forecast" && (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, minmax(120px, 1fr))",
                      gap: 1.5,
                      alignItems: "center",
                      marginLeft: "auto",
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                        Forecast Published Date
                      </Typography>
                      <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                        {forecastDateInfo.published}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                        Current SAP Forecast Date
                      </Typography>
                      <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                        {forecastDateInfo.current}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                        Confirmation Date
                      </Typography>
                      <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                        {forecastDateInfo.confirmation}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                        Extraction Date
                      </Typography>
                      <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                        {forecastDateInfo.extraction}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>

              <Box sx={{ height: "48vh" }}>
                <GraphComponent
                  className="modal-graph"
                  data={modalGraphData || graphConfig[activeGraph]?.data}
                  options={modalChartOptions}
                />
              </Box>
            </Box>
          ) : null
        }
      />

      


    </Box>
  );
};

export default SuplierDetails;
